var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Mention from "@tiptap/extension-mention";
import { PluginKey } from "prosemirror-state";
import { createSuggestionRenderer, createNodeView } from "src/decidim/editor/common/suggestion";
export const MentionResourcePluginKey = new PluginKey("mentionResource");
const searchResources = (queryText) => __async(null, null, function* () {
  var _a;
  const currentParticipatorySpace = (_a = document.querySelector("meta[name='context-current-participatory-space']")) == null ? void 0 : _a.content;
  let url = `/resource_autocomplete?term=${queryText}`;
  if (currentParticipatorySpace) {
    url += `&participatory_space_gid=${currentParticipatorySpace}`;
  }
  return new Promise((resolve, reject) => {
    Rails.ajax({
      url,
      type: "GET",
      dataType: "json",
      success: (response) => resolve(response),
      error: () => reject(new Error("Could not retrieve data"))
    });
  });
});
export default Mention.extend({
  name: "mentionResource",
  addOptions() {
    var _a;
    const options = (_a = this.parent) == null ? void 0 : _a.call(this);
    const suggestion = options == null ? void 0 : options.suggestion;
    return __spreadProps(__spreadValues({}, options), {
      renderText({ node }) {
        var _a2;
        return (_a2 = node.attrs.label) != null ? _a2 : node.attrs.id;
      },
      suggestion: __spreadProps(__spreadValues({}, suggestion), {
        char: "/",
        pluginKey: MentionResourcePluginKey,
        allowSpaces: false,
        items: (_0) => __async(this, [_0], function* ({ query }) {
          const data = yield searchResources(query);
          return data;
        }),
        render: createSuggestionRenderer(this, {
          itemConverter: (resource) => {
            return {
              id: resource.gid,
              label: resource.title,
              help: resource.help
            };
          }
        })
      })
    });
  },
  renderHTML({ node }) {
    var _a;
    return [
      "span",
      {
        "data-type": "mentionResource",
        "data-id": node.attrs.id,
        "data-label": node.attrs.label
      },
      (_a = node.attrs.label) != null ? _a : node.attrs.id
    ];
  },
  addNodeView() {
    return createNodeView(this);
  }
});
